import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./QuizListContainer.css";
import { Card, CardImg, CardTitle, CardImgOverlay, CardText } from "reactstrap";
import { useEffect } from "react";
import { _getAllQuizz } from "@src/redux/action/quizz/QuizzAction.js";
import BreadCrumbs from "@components/breadcrumbs/index1";
import { useDispatch, useSelector } from "react-redux";
import { CustomPagination } from "@store/action/GlobalAction";
import { useState } from "react";
import { Input, Label } from "reactstrap";
const QuizList = () => {
  const [perPage, setPerPage] = useState(5);
  const [page, setPage] = useState(1);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const quizzList = useSelector((store) => store.QuizzReducer._listquiz);
  const count = useSelector((store) => store.QuizzReducer._quiz_total);

  useEffect(() => {
    _getAllQuizz(perPage, page, dispatch);
  }, [page, perPage]);

  const FrontofficeThemeReducer = useSelector(
    (state) => state.FrontofficeThemeReducer
  );
  const themeStore = FrontofficeThemeReducer;
  const tempalte = themeStore?.design_by_radio?.templates.id;
  const handelPagination = (page) => {
    setPage(page.selected + 1);
  };
  return (
    <div>
      {tempalte === 2 ? (
        <BreadCrumbs breadCrumbTitle={t("Quiz")} />
      ) : (
        <section className="single-banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="single-content">
                  <h2>{t("Quiz")}</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">{t("Home")}</Link>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          flexDirection: "column"
        }}
      >
        <div className=" align-items-center ">
          {/* <Button color="primary" onClick={toggleSidebar}>
                <span className="align-middle ">{t("Add Vote")}</span>
              </Button> */}
          <Label>{t("per page")} </Label>{" "}
          <Input
            style={{ width: "80px" }}
            onChange={(perpage) => {
              setPerPage(perpage.target.value);
            }}
            type="select"
          >
            <option value={5}>5</option>
            <option value={7}>7</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
            <option value={25}>25</option>
            <option value={30}>30</option>
            <option value={35}>35</option>
            <option value={1940}>all</option>
          </Input>
        </div>
        <div className="_QuizListContainer">
          {quizzList.map(
            (ele, i) =>
              ele.status && (
                <Link to={`/Quiz/QuizList/${ele.id}`}>
                  <Card
                    key={"quiz2List" + i}
                    style={{
                      height: "240px",
                      margin: "50px",
                      width: "450px",
                      margin: "10px"
                    }}
                    className="text-white border-0"
                  >
                    <CardImg
                      top
                      src={
                        "https://static.vecteezy.com/system/resources/thumbnails/006/691/884/small/blue-question-mark-background-with-text-space-quiz-symbol-vector.jpg"
                      }
                      alt="card-overlay"
                    />
                    <CardImgOverlay className="bg-overlay">
                      <CardTitle className="text-white" tag="h4">
                        {ele.title}
                      </CardTitle>

                      <CardText
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <p>{t("votes number : ")}</p>
                        <small
                          style={{
                            margin: "2px"
                          }}
                          className="text-muted"
                        >
                          {ele.sumVotes}
                        </small>
                      </CardText>
                    </CardImgOverlay>
                  </Card>
                </Link>
              )
          )}
        </div>
        {CustomPagination(count, perPage, handelPagination)}
      </section>
    </div>
  );
};
export default QuizList;
